import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { User } from 'lib-shared-types-api';
import { Channel } from 'lib-shared-types-channels';

import { bansApi } from 'apis/bans';
import { useNotifications } from 'hooks/useNotifications';
import { channelAttributes } from 'utils/channels';

type UnbanUserModalProps = {
  user: User;
  channel: Channel;
  isOpen: boolean;
  onClose: (canceled: boolean) => void;
};

export const UnbanUserModal = ({
  isOpen,
  user: { id, name },
  channel,
  onClose,
}: UnbanUserModalProps): JSX.Element => {
  const [unbanUser, { isLoading }] = bansApi.useUpdateUserUnbanMutation();

  const notify = useNotifications();

  const handleConfirm = async () => {
    ampli.bansUnbanUserClicked({
      channel,
    });

    try {
      await unbanUser({
        userId: id,
        channel,
      }).unwrap();

      notify({
        title: 'User unbanned',
        text: `User has been unbanned`,
        icon: 'i-done',
        className: 'success',
        time: 5000,
      });

      onClose(false);
    } catch {
      notify({
        title: 'An error occurred',
        text: `An error occurred when trying to unban user`,
        icon: 'i-exclamation',
        className: 'danger',
      });
    }
  };

  const channelName = channelAttributes[channel]?.name;

  return (
    <Modal isOpen={isOpen} onClose={() => onClose(true)}>
      <ModalHead title="Are you sure?" onClose={() => onClose(true)} />
      <ModalBody>
        <Text.Paragraph>
          Are you sure you want to unban user <strong>{name}</strong> from the{' '}
          <strong>{channelName}</strong> channel?
        </Text.Paragraph>
      </ModalBody>
      <ModalFoot
        cancelName="Cancel"
        cancelOnClick={() => onClose(true)}
        confirmName="Unban user"
        confirmProps={{
          isLoading,
          loadingIndicator: (
            <Text.Paragraph as="span" variant="3" wrap="nowrap" color="inherit">
              Unbanning...
            </Text.Paragraph>
          ),
        }}
        confirmOnClick={handleConfirm}
      ></ModalFoot>
    </Modal>
  );
};
